// eslint-disable-next-line import/prefer-default-export
export const EmployeeSelectionReportSortColumn = Object.freeze({
    NAME: 0,
    RANK: 1,
    PREFERENCE: 2,
    BID_SELECTION: 3,
    CURRENT_BID_AWARDING: 4,
});
